import React, { createContext, useContext } from 'react';
import type { LibraryItemType } from '~/modules/directory/hook/use-set-in-library';

interface LibraryActionContextValue {
    removeFromLibrary?: (
        itemType: LibraryItemType,
        itemId: number,
        itemName: string,
    ) => void;
    /**
     * IDs currently fading out — keep tile mounted with opacity-0 so the
     * fade animation can play.
     */
    removedFromLibraryIds?: Set<number>;
    /**
     * IDs whose fade animation has finished — filter these from the source
     * array so the grid reflows and fills the empty cell.
     */
    unmountedFromLibraryIds?: Set<number>;
}

const LibraryActionContext = createContext<LibraryActionContextValue>({});

export const LibraryActionProvider = ({
    value,
    children,
}: {
    value: LibraryActionContextValue;
    children: React.ReactNode;
}) => (
    <LibraryActionContext.Provider value={value}>
        {children}
    </LibraryActionContext.Provider>
);

export const useLibraryAction = () => useContext(LibraryActionContext);
